// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';

const ProductViews = ({children}) =>
    <section>
        {children}
    </section>;

ProductViews.displayName = 'ProductViews';
ProductViews.propTypes = {
    children: PropTypes.node
};

export default ProductViews;



// WEBPACK FOOTER //
// ./src/product/shared/components/product-views.js